import { render, staticRenderFns } from "./FieldSelect.vue?vue&type=template&id=5635be0c"
import script from "./FieldSelect.vue?vue&type=script&lang=js"
export * from "./FieldSelect.vue?vue&type=script&lang=js"
import style0 from "./FieldSelect.vue?vue&type=style&index=0&id=5635be0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports